export const paginationOptions = {
  enabled: true,
  mode: "records", // Ensure this is set to 'records'
  perPage: 10, // Set the number of records per page
  setCurrentPage: 1,
  dropdownAllowAll: false,
}